import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-amount-item-renderer',
  templateUrl: './amount-item-renderer.component.html',
  styleUrls: ['./amount-item-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmountItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: number;

  constructor() {}

  ngOnInit(): void {}
}
